import { Divider, Flex, Icon, Text, Input, HStack, VStack, FormControl, FormLabel, Button } from '@chakra-ui/react'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { BsArrowCounterclockwise, BsSearch } from 'react-icons/bs'
import FormSearch from '../../classes/FormSearch'
import { useSearchQueryContext } from '../../context/searchQueryContext'
import { SelectFormApproveStatus, SelectFormStatus, SelectMonth, SelectResidence, SelectYear } from '../shared'

const SearchForm = () => {
    const defaultValues = FormSearch.DEFAULT_VALUE
    const { control, handleSubmit, reset } = useForm({ defaultValues })
    const { setQuery } = useSearchQueryContext()

    const onSubmit = (data) => {
        const value = new FormSearch(data)
        // console.log('submit')
        // console.log(value.serialized())
        setQuery(value.serialized())
    }

    const resetForm = () => {
        reset(defaultValues)
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <VStack mt={4} w="full">
                <HStack w="full">
                    <FormControl>
                        <FormLabel>ชื่อ-นามสกุล</FormLabel>
                        <Controller
                            name="name"
                            control={control}
                            render={({ field }) => <Input type="text" maxLength={100} placeholder="กรอกชื่อ หรือนามสกุล" {...field} />}
                        />
                    </FormControl>
                    <FormControl>
                        <FormLabel>วันที่ยื่น (เดือน)</FormLabel>
                        <SelectMonth control={control} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>วันที่ยื่น (ปี)</FormLabel>
                        <SelectYear control={control} />
                    </FormControl>
                </HStack>
                <HStack w="full">
                    <FormControl>
                        <FormLabel>อาคาร</FormLabel>
                        <SelectResidence control={control} useShortName={true} required={false} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>สถานะแบบคำร้อง</FormLabel>
                        <SelectFormStatus control={control} />
                    </FormControl>
                    <FormControl>
                        <FormLabel>สถานะการตรวจสอบ</FormLabel>
                        <SelectFormApproveStatus control={control} />
                    </FormControl>
                </HStack>
                <HStack>
                    <Button type="submit" colorScheme="blue" fontSize="md" leftIcon={<BsSearch />}>
                        ค้นหา
                    </Button>
                    <Button type="reset" colorScheme="yellow" fontSize="md" leftIcon={<BsArrowCounterclockwise />} onClick={() => resetForm()}>
                        ล้างฟอร์ม
                    </Button>
                </HStack>
            </VStack>
        </form>
    )
}

const SearchPanel = () => {
    return (
        <Flex w="full" direction="column" p={4} shadow="lg" borderRadius={4}>
            <Text><Icon as={BsSearch} mr={2} />ค้นหา</Text>
            <Divider />
            <SearchForm />
        </Flex>
    )
}

export default SearchPanel
